import React from "react";
import { useT } from "@/i18n";

const items_en = [
  "TOP-CAST® SURFACE RETARDER",
  "DAYTON SUPERIOR",
  "WATER-BASED FORMULATION",
  "12 DEPTHS OF ETCH",
  "EXPOSED AGGREGATE FINISHES",
  "AVAILABLE IN MONTRÉAL",
  "ARCHITECTURAL CONCRETE",
  "PRECISION ENGINEERED",
];
const items_fr = [
  "TOP-CAST® RETARDATEUR DE SURFACE",
  "DAYTON SUPERIOR",
  "FORMULATION À BASE D'EAU",
  "12 PROFONDEURS DE GRAVURE",
  "FINITIONS DE GRANULAT EXPOSÉ",
  "DISPONIBLE À MONTRÉAL",
  "BÉTON ARCHITECTURAL",
  "PRÉCISION D'INGÉNIERIE",
];

const Marquee = () => {
  const { lang } = useT();
  const items = lang === "fr" ? items_fr : items_en;
  const loop = [...items, ...items];
  return (
    <section
      data-testid="marquee-section"
      className="border-y border-black/10 bg-[#faf7f2] py-6 overflow-hidden"
    >
      <div className="flex marquee-track whitespace-nowrap">
        {loop.map((t, i) => (
          <div key={i} className="flex items-center gap-10 px-6">
            <span className="font-display text-2xl sm:text-3xl text-[#14141a]/85 tracking-tight">{t}</span>
            <span className="text-[#ea7a1f] text-xl">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
